export default {
    methods: {
        fareHarborMode() {
            return window.application.mixFareharborMode === 1 || window.application.mixFareharborMode === '1';
        },
        openFareHarborModal() {
            const flow = window.application.mixFareharborFlow || '';
            const fareHarborModalObject = { shortname: 'bikerentnyc', fallback: 'simple', fullItems: 'yes', view: 'items' }

            if(flow) {
                fareHarborModalObject.flow = flow;
            }
            return !(window.FH && FH.open(fareHarborModalObject));
        },
        fareHarborModeLink() {
            if (window.application.mixFareharborMode === 1 || window.application.mixFareharborMode === '1') {

                const flow = window.application.mixFareharborFlow ? `&flow=${window.application.mixFareharborFlow}` : ''

                return `https://fareharbor.com/embeds/book/bikerentnyc/?full-items=yes${flow}`
            }

            return '';
        },
    }
}
